/* NutriCals glass header: adaptive tone.
   Samples the page behind the pill's midpoint and toggles
   .nc-header--light on .section-header over light sections.
   Any section can force a mode with data-nc-header-tone="light|dark".
   No-ops safely on old browsers; the header then stays dark. */
(function () {
  'use strict';

  var header = document.querySelector('.section-header');
  if (!header || !document.elementsFromPoint) return;

  var LIGHT_CLASS = 'nc-header--light';
  var current = null;
  var ticking = false;

  function channel(v) {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  }

  function luminance(c) {
    return 0.2126 * channel(c.r) + 0.7152 * channel(c.g) + 0.0722 * channel(c.b);
  }

  function parseColor(str) {
    var m = str && str.match(/rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s/]+([\d.]+))?\s*\)/);
    if (!m) return null;
    return { r: +m[1], g: +m[2], b: +m[3], a: m[4] === undefined ? 1 : +m[4] };
  }

  /* Walk up until a background opaque enough to define the tone. */
  function effectiveBackground(el) {
    while (el && el !== document.documentElement) {
      var c = parseColor(getComputedStyle(el).backgroundColor);
      if (c && c.a > 0.5) return c;
      el = el.parentElement;
    }
    var body = parseColor(getComputedStyle(document.body).backgroundColor);
    return body && body.a > 0.5 ? body : { r: 255, g: 255, b: 255 };
  }

  function sample() {
    ticking = false;
    var rect = header.getBoundingClientRect();
    /* Sample just below the header: at rest that is the first
       section it sits on; once floating it is the content passing
       under the pill. Sampling inside the header's own band would
       hit the page body and misclassify dark pages as light. */
    var y = Math.max(0, Math.min(rect.bottom + 2, window.innerHeight - 1));
    var x = window.innerWidth / 2;
    var stack, i, target = null;
    try {
      stack = document.elementsFromPoint(x, y);
    } catch (e) {
      return;
    }
    for (i = 0; i < stack.length; i++) {
      if (stack[i] !== header && !header.contains(stack[i])) {
        target = stack[i];
        break;
      }
    }
    if (!target) return;

    var tone;
    var owner = target.closest ? target.closest('[data-nc-header-tone]') : null;
    if (owner) {
      tone = owner.getAttribute('data-nc-header-tone') === 'light' ? 'light' : 'dark';
    } else {
      var L = luminance(effectiveBackground(target));
      /* Hysteresis: the mid band keeps the current mode so gradients
         and boundaries cannot flicker it. */
      if (L > 0.6) tone = 'light';
      else if (L < 0.45) tone = 'dark';
      else tone = current || 'dark';
    }

    if (tone !== current) {
      current = tone;
      header.classList.toggle(LIGHT_CLASS, tone === 'light');
    }
  }

  function schedule() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(sample);
    }
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sample);
  } else {
    sample();
  }
})();
